module.exports = __webpack_public_path__ + "static/media/preventative.8c0cd97d.jpg";